import { render, staticRenderFns } from "./MainTabMenu.vue?vue&type=template&id=6c21f291"
import script from "./MainTabMenu.vue?vue&type=script&lang=js"
export * from "./MainTabMenu.vue?vue&type=script&lang=js"
import style0 from "./MainTabMenu.vue?vue&type=style&index=0&id=6c21f291&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports